import { TimeStandard, TimezoneOffset, TimezoneOffsetText } from './constants'
import type { LocaleConfig } from './type'

enum TimezoneTH {
  BANGKOK = 'Asia/Bangkok',
}

const localeConfig: LocaleConfig = {
  helpCenterUrl: 'https://help.shopee.co.th/portal/category/16624-ShopeeFood?source=1',
  /**
   * timezone
   */
  defaultTimezone: TimezoneTH.BANGKOK,
  getTimezone: (timezone?: string) => {
    const lowerTimezone = timezone?.toLowerCase()
    const config = {
      [TimezoneTH.BANGKOK.toLowerCase()]: {
        timezoneStandardText: TimeStandard.WIB,
        timezoneOffset: TimezoneOffset.UTC7,
        timezoneOffsetText: TimezoneOffsetText[TimezoneOffset.UTC7],
        timezoneName: TimezoneTH.BANGKOK,
      },
    }
    return config[lowerTimezone as TimezoneTH] || config[TimezoneTH.BANGKOK.toLowerCase()]
  },

  currency: {
    CODE: 'THB',
    LOCALES: 'th-TH',
    SYMBOL: '฿',
    MIN_FRACTION_DIGITS: 2,
    MAX_FRACTION_DIGITS: 5,
  },

  wallet: {
    availableBalanceReachAmount: '20000000',
  },

  price: {
    regExp: /^[\d]+$/,
    precision: 0,
  },

  menu: {
    dish: {
      minPrice: 0.01,
      maxPrice: 10000000,
    },
  },
}

export default localeConfig
